export default {
  state: {
    recommendations: [],
    domains: [],
    loading: false,
    lastUpdated: null,
    error: null,
    cache: {}
  },

  mutations: {
    SET_AI_RECOMMENDATIONS(state, recommendations) {
      state.recommendations = recommendations
      // Persist to sessionStorage
      try {
        sessionStorage.setItem(
          'ai_recommendations',
          JSON.stringify(recommendations)
        )
      } catch (error) {
        console.error(
          'Error storing AI recommendations to sessionStorage:',
          error
        )
      }
    },
    SET_AI_DOMAINS(state, domains) {
      state.domains = domains
      // Persist to sessionStorage
      try {
        sessionStorage.setItem('ai_domains', JSON.stringify(domains))
      } catch (error) {
        console.error('Error storing AI domains to sessionStorage:', error)
      }
    },
    SET_AI_LOADING(state, loading) {
      state.loading = loading
    },
    SET_AI_ERROR(state, error) {
      state.error = error
    },
    SET_AI_LAST_UPDATED(state, timestamp) {
      state.lastUpdated = timestamp
      // Persist to sessionStorage
      try {
        sessionStorage.setItem('ai_last_updated', timestamp)
      } catch (error) {
        console.error('Error storing AI last updated to sessionStorage:', error)
      }
    },
    CLEAR_AI_RECOMMENDATIONS(state) {
      state.recommendations = []
      state.domains = []
      state.error = null
      // Clear from sessionStorage
      try {
        sessionStorage.removeItem('ai_recommendations')
        sessionStorage.removeItem('ai_domains')
      } catch (error) {
        console.error('Error clearing AI data from sessionStorage:', error)
      }
    },
    CACHE_RESULTS(state, { domain, results }) {
      state.cache[domain] = {
        provider: 'OpenRouter',
        results
      }
      // Persist to sessionStorage
      try {
        sessionStorage.setItem('ai_cache', JSON.stringify(state.cache))
      } catch (error) {
        console.error('Error storing AI cache to sessionStorage:', error)
      }
    },
    // Load data from sessionStorage on app init
    INIT_FROM_STORAGE(state) {
      try {
        const recommendations = sessionStorage.getItem('ai_recommendations')
        const domains = sessionStorage.getItem('ai_domains')
        const lastUpdated = sessionStorage.getItem('ai_last_updated')
        const cache = sessionStorage.getItem('ai_cache')

        if (recommendations) {
          const parsedRecommendations = JSON.parse(recommendations)
          state.recommendations = Array.isArray(parsedRecommendations)
            ? parsedRecommendations.filter(
                recommendation => recommendation?.aiModel === 'OpenRouter'
              )
            : []
        }
        if (domains) {
          state.domains = JSON.parse(domains)
        }
        if (lastUpdated) {
          state.lastUpdated = lastUpdated
        }
        if (cache) {
          state.cache = JSON.parse(cache)
        }
      } catch (error) {
        console.error('Error loading AI data from sessionStorage:', error)
      }
    }
  },

  actions: {
    setAiRecommendations({ commit }, recommendations) {
      commit('SET_AI_RECOMMENDATIONS', recommendations)
      commit('SET_AI_LAST_UPDATED', new Date().toISOString())
    },
    setAiDomains({ commit }, domains) {
      commit('SET_AI_DOMAINS', domains)
    },
    setAiLoading({ commit }, loading) {
      commit('SET_AI_LOADING', loading)
    },
    setAiError({ commit }, error) {
      commit('SET_AI_ERROR', error)
    },
    clearAiRecommendations({ commit }) {
      commit('CLEAR_AI_RECOMMENDATIONS')
    },
    cacheResults({ commit }, { domain, results }) {
      commit('CACHE_RESULTS', { domain, results })
    },
    // Action to initialize state from sessionStorage
    initAiFromStorage({ commit }) {
      commit('INIT_FROM_STORAGE')
    }
  },

  getters: {
    getAiRecommendations: state => state.recommendations,
    getAiDomains: state => state.domains,
    hasAiRecommendations: state => state.recommendations.length > 0,
    getAiLastUpdated: state => state.lastUpdated,
    isAiLoading: state => state.loading,
    getAiError: state => state.error,
    getCachedResults: state => domain =>
      state.cache[domain]?.provider === 'OpenRouter'
        ? state.cache[domain].results
        : null
  }
}
